import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { CategoryStorageType } from '../../../../types';
import { getBscGlobalState } from '../../bsc-global-state';
import { cache } from '../../cached-sampling-config';
import { isSSR } from '../../is-ssr';
// In case we are unable to load the config file, don't provide a specific key, or make a mistake and
// remove a sampling key, we'd like to set some reasonable defaults to avoid: A) not emitting events
// at all, or B) sending ALL events without any sampling.
export var samplingDefaults = {
  usedGetCookie: 100000,
  usedGetCookieError: 1,
  usedSetCookie: 1000,
  usedSetCookieError: 1,
  usedSetStrictlyNecessaryCookie: 10000,
  usedSetStrictlyNecessaryCookieError: 1,
  usedDeleteCookie: 10,
  usedDeleteCookieError: 1,
  usedCheckThirdParty: 100000,
  checkThirdPartyError: 1,
  usedDocumentCookie: 100,
  usedDocumentCookieError: 1,
  initializeControlsError: 1,
  loadStorageControlsError: 1,
  updatePreferencesError: 1,
  fetchConsentPreferencesError: 1,
  saveConsentPreferencesError: 1,
  usedAtlBrowserStorageGetItem: 100,
  usedAtlBrowserStorageGetItemError: 1,
  usedAtlBrowserStorageSetItem: 100,
  usedAtlBrowserStorageSetItemError: 1,
  usedAtlBrowserStorageSetStrictlyNecessaryItem: 100,
  usedAtlBrowserStorageSetStrictlyNecessaryItemError: 1,
  indexDbSetRecordError: 1,
  usedCheckIfSetByPackageError: 1,
  renderConsentBannerError: 1,
  bannerAppearanceAfterDismissal: 1
};

// This short-circuits finding a sampling ratio from the remote config. Useful for things like
// `loadStorageControlsError` which itself tries to log an event on error, causing an infinite
// recursion as each lookup fails, logging another event, etc.
var localOnlySamplingKeys = ['loadStorageControlsError'];
function loadSamplingConfig() {
  return _loadSamplingConfig.apply(this, arguments);
}
function _loadSamplingConfig() {
  _loadSamplingConfig = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _getBscGlobalState, loadCache, controlsData, analyticsSamplingRatioConfigs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!cache.cachedSamplingConfig) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return", cache.cachedSamplingConfig);
        case 2:
          if (!isSSR()) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", undefined);
        case 4:
          _getBscGlobalState = getBscGlobalState(), loadCache = _getBscGlobalState.loadCache;
          _context.next = 7;
          return loadCache(CategoryStorageType.Cookies);
        case 7:
          controlsData = _context.sent;
          analyticsSamplingRatioConfigs = controlsData === null || controlsData === void 0 ? void 0 : controlsData.analyticsSamplingRatio;
          cache.cachedSamplingConfig = analyticsSamplingRatioConfigs;
          return _context.abrupt("return", analyticsSamplingRatioConfigs);
        case 11:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _loadSamplingConfig.apply(this, arguments);
}
export function getAnalyticsSamplingRatio(_x) {
  return _getAnalyticsSamplingRatio.apply(this, arguments);
}
function _getAnalyticsSamplingRatio() {
  _getAnalyticsSamplingRatio = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(analyticsEventKey) {
    var remoteSamplingConfig, samplingConfig, samplingRatio;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!localOnlySamplingKeys.includes(analyticsEventKey)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return", samplingDefaults[analyticsEventKey]);
        case 2:
          _context2.next = 4;
          return loadSamplingConfig();
        case 4:
          remoteSamplingConfig = _context2.sent;
          samplingConfig = remoteSamplingConfig !== null && remoteSamplingConfig !== void 0 ? remoteSamplingConfig : samplingDefaults;
          samplingRatio = (samplingConfig === null || samplingConfig === void 0 ? void 0 : samplingConfig[analyticsEventKey]) !== undefined ? samplingConfig[analyticsEventKey] : samplingDefaults[analyticsEventKey];
          return _context2.abrupt("return", samplingRatio);
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _getAnalyticsSamplingRatio.apply(this, arguments);
}
export function withSampling(samplingRatio, cb) {
  /* Only run if rolling the samplingRatio-sized die lands on a 0
        ________
       /\       \
      /()\   ()  \
     /    \_______\
     \    /()     /
      \()/   ()  /
       \/_____()/
   */
  var shouldRun = !Math.floor(Math.random() * samplingRatio);
  shouldRun && cb();
}
export function withAnalyticsEventSampling(_x2, _x3) {
  return _withAnalyticsEventSampling.apply(this, arguments);
}
function _withAnalyticsEventSampling() {
  _withAnalyticsEventSampling = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(analyticsEventKey, cb) {
    var ratio;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return getAnalyticsSamplingRatio(analyticsEventKey);
        case 2:
          ratio = _context3.sent;
          withSampling(ratio, cb);
        case 4:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _withAnalyticsEventSampling.apply(this, arguments);
}